import ROUTES from 'constants/routes';
import { NavLink } from 'react-router-dom';
import './styles.scss';
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';

const legalPages = [
    { name: 'Terms and Conditions', to: ROUTES.terms_and_conditions },
    { name: 'Privacy Policy', to: ROUTES.privacy_policy },
    { name: 'Refund Policy', to: ROUTES.refund_policy },
];




const SidebarLegalInfo = ({ loading }) => {
    const container = useRef();
    useAnimation({
        items: ['.legal-info-sidebar',],
        container,
        dependencies: [loading],
    })
    return (
        <div ref={container}>
            <div className="legal-info-sidebar">
                {legalPages.map(({ to, name }) => (
                    <NavLink key={to} className="legal-info-sidebar__item" to={to}>
                        {name}
                        <div className='post-anchors-item__dot'></div>
                    </NavLink>
                ))}
            </div>
        </div>

    );
}

export default SidebarLegalInfo;
